// src/auth/AppContent.js
import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import { verifyUser } from "../store/Auth/authThunks";
import { Outlet } from "react-router-dom";

import AppTheme from "../theme/AppTheme";
import { ThemeSettingsProvider } from "../theme/ThemeSettingsContext";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import TrainingVideoGate from "../pages/Users/Components/TrainingVideoGate";

export default function AppContent({ children }) {
  const dispatch = useDispatch();
  const { isLoading } = useAuth0();

  const user = useSelector((state) => state.auth.user);
  const authInitialized = useSelector((state) => state.auth.initialized);

  const [showTrainingVideo, setShowTrainingVideo] = useState(false);

  // Handle training video logic
  useEffect(() => {
    if (authInitialized && user && user.has_seen_training_video === false) {
      setShowTrainingVideo(true);
    }
  }, [authInitialized, user]);

  // Only show spinner while Auth0 initializes
  // Let PrivateRoute handle backend verification
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (showTrainingVideo) {
    return (
      <TrainingVideoGate
        onComplete={() => {
          setShowTrainingVideo(false);
          dispatch(verifyUser());
        }}
      />
    );
  }

  return (
    <ThemeSettingsProvider>
      <AppTheme>
        <Box sx={{ width: "100vw", height: "100vh" }}>
          {children ?? <Outlet />}
        </Box>
      </AppTheme>
    </ThemeSettingsProvider>
  );
}
